// Development environment
export const environment = {
  production: false,
  name: 'development',
  creditAgreementUrl: 'https://outdoor-website-kgneh6dcsq-uk.a.run.app/terms',
  apiUrl: 'https://slt-commandcenter-backend-124917071187.us-east4.run.app/api/v1',
  allowedOrigins: ['*'],
  targetOrigin: '*',
};
